// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"362":"9265bdb0","670":"d67526ed","676":"25e82dcb","830":"31e6b5ae"}[chunkId] + ".css";
};